import type { ReactNode } from 'react';

export const symbol_window_sensor: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M889.82-620q-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-160q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v160q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63ZM120-180v-600q0-24.75 17.63-42.38Q155.25-840 180-840h520q24.75 0 42.38 17.62Q760-804.75 760-780v600q0 24.75-17.62 42.37Q724.75-120 700-120H180q-24.75 0-42.37-17.63Q120-155.25 120-180Zm60-330h220v-25q0-6 4.5-10.5T415-550h50q6 0 10.5 4.5T480-535v25h220v-270H180v270Zm0 330h520v-270H180v270Zm0 0h520-520Z"
		/>
	</svg>
);
